import React from "react";
import {CButton} from "@coreui/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint } from '@fortawesome/free-solid-svg-icons'

const PrintButton = ({value , onClick}) => {
  return(
    <>
      <CButton className="btn btn-link" onClick={onClick && onClick}>
        <span className="text-dark"><FontAwesomeIcon icon={faPrint}/>{value ? ` ${value}` : ''}</span>
      </CButton>
    </>
  )
}
export default PrintButton

export const PrintCustomButton = ({value , onClick}) => {
  return(
    <>
      <CButton className="btn btn-link" onClick={onClick && onClick}>
        <span className="text-success"><FontAwesomeIcon icon={faPrint}/>{value ? ` ${value}` : ''}</span>
      </CButton>
    </>
  )
}